import Difficulty from 'app/frontend/types/custom/Difficulty'
import Season from 'app/frontend/types/custom/Season'
import { createContext } from 'react'
import { EditableWish } from './types'

export const LootContext = createContext<{
  selectedSeason: Season
  setSelectedSeason: (season: Season) => void
  difficulty: Difficulty
  setDifficulty: (difficulty: Difficulty) => void
  droptimizerConfigurations: wowaudit.DroptimizerConfiguration[]
  configuration: wowaudit.DroptimizerConfiguration
  setConfiguration: (configuration: wowaudit.DroptimizerConfiguration) => void
  valueDisplay: string
  setValueDisplay: (valueDisplay: string) => void
}>({
  selectedSeason: {} as Season,
  setSelectedSeason: () => null,
  difficulty: 'mythic',
  setDifficulty: () => null,
  droptimizerConfigurations: [],
  configuration: {} as wowaudit.DroptimizerConfiguration,
  setConfiguration: () => null,
  valueDisplay: 'percentage',
  setValueDisplay: () => null,
})

export const PersonalLootContext = createContext<{
  characterReference: wowaudit.CharacterReference
  editing: boolean
  setEditing: (editing: boolean) => void
  changes: Record<string, EditableWish>
  setChanges: (changes: Record<string, EditableWish>) => void
}>({
  characterReference: {} as wowaudit.CharacterReference,
  editing: false,
  setEditing: () => null,
  changes: {},
  setChanges: () => null,
})
